module.exports = __webpack_public_path__ + "static/media/league-gothic.cd382dc8.woff";